import React from "react";

const ConsumerFreezeAPermanentOption = (props: any) => {
    return (
        <div>
            <p>
                A Protected Consumer Freeze will remain on the minor's TransUnion credit file until the guardian submits a written request for its removal, or the
                minor turns 16 at which point they can request the removal themselves.
            </p>
        </div>
    );
};

export default ConsumerFreezeAPermanentOption;
